import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const transactionsApi = api
  .enhanceEndpoints({ addTagTypes: ["transactions"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createTransaction: builder.mutation({
        query: ({
          branchId,
          name,
          description,
          amount,
          currency,
          client,
          taxId,
          paymentMethod,
          type,
        }) => ({
          url: `branchs/${branchId}/transactions`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            description,
            amount,
            currency,
            client,
            taxId,
            paymentMethod,
            type,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        invalidatesTags: ["transactions"],
      }),
      deleteTransaction: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `branchs/${branchId}/transactions/${id}`,
          method: RequestMethod.DELETE,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        invalidatesTags: ["transactions"],
      }),
      transactions: builder.query({
        query: ({
          branchId,
          branchIds,
          currency,
          minAmount,
          maxAmount,
          personalIds,
          startDate,
          endDate,
          page,
        }) => ({
          url: `branchs/${branchId}/transactions`,
          method: RequestMethod.GET,
          params: camelToSnake({
            startDate,
            endDate,
            currency,
            minAmount,
            maxAmount,
            personalIds,
            branchIds: branchIds,
            page,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["transactions"],
      }),
      exportTransactions: builder.query({
        query({
          branchId,
          currency,
          minAmount,
          maxAmount,
          personalIds,
          startDate,
          endDate,
          branchIds,
          page,
        }) {
          return {
            url: `branchs/${branchId}/transactions/export`,
            method: RequestMethod.GET,
            responseHandler: async (response) =>
              window.location.assign(
                window.URL.createObjectURL(await response.blob())
              ),
            params: camelToSnake({
              startDate,
              endDate,
              currency,
              minAmount,
              maxAmount,
              personalIds,
              branchIds,
              page,
            }),
            cache: "no-cache",
          };
        },
      }),
      transactionTicket: builder.query({
        query({ branchId, id }) {
          return {
            url: `branchs/${branchId}/transactions/${id}/ticket`,
            method: RequestMethod.GET,
            responseHandler: async (response) =>
              window.open(
                window.URL.createObjectURL(await response.blob()),
                "_blank"
              ),
            cache: "no-cache",
          };
        },
      }),
      importXML: builder.mutation({
        query: ({
          branchId,
          name,
          description,
          amount,
          currency,
          client,
          taxId,
          paymentMethod,
          type,
        }) => ({
          url: `branchs/${branchId}/transactions`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            description,
            amount,
            currency,
            client,
            taxId,
            paymentMethod,
            type,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        invalidatesTags: ["transactions"],
      }),
      exportDebit: builder.query({
        query({
          branchId,
          currency,
          minAmount,
          maxAmount,
          personalIds,
          startDate,
          endDate,
          page,
        }) {
          return {
            url: `branchs/${branchId}/accountings/export`,
            method: RequestMethod.GET,
            responseHandler: async (response) =>
              window.location.assign(
                window.URL.createObjectURL(await response.blob())
              ),
            params: camelToSnake({
              startDate,
              endDate,
              currency,
              minAmount,
              maxAmount,
              personalIds,
              page,
            }),
            cache: "no-cache",
          };
        },
      }),
    }),
  });

export const {
  useTransactionsQuery,
  useCreateTransactionMutation,
  useDeleteTransactionMutation,
  useLazyExportTransactionsQuery,
  useLazyTransactionTicketQuery,
  useImportXMLMutation,
  useExportDebitQuery

} = transactionsApi;
